import React, { useRef, useState } from 'react';
import { getOrderStatus } from '../PITLSummary';
import CollectionPackSummary from './CollectionPackSummary';

/**
 * Display the list of products on this order.
 * If the products have been accessioned we will show appropriate buttons (like "View Results").
 * If not accessioned, show the requisition name.
 *
 * @param gearOrder The gear order
 * @param setLoading A function to call to display a loading shield and spinner
 * @param setGearOrder A function to pass the updated gearOrder back up the tree
 */
export const OrderedProducts = ({ gearOrder, userInfo, setLoading, setGearOrder }) => {
	const [actionResponse, setActionResponse] = useState(null);
	/**
	 * Keep track of the initial order status so we can continue to show Sample Collection buttons
	 * after new sample collection details are saved.
	 * If we recalculate the order status on each render the buttons will go away once sample
	 * collection details are saved, causing the status to change.
	 */
	const initialRef = useRef({ orderStatus: getOrderStatus(gearOrder) });

	if (!gearOrder?.requisitions?.length) {
		return null;
	}

	let productSections = gearOrder.requisitions.map((gearReq) => (
		<CollectionPackSummary
			key={gearReq.id}
			gearOrder={gearOrder}
			gearReq={gearReq}
			initialOrderStatus={initialRef.current.orderStatus}
			userInfo={userInfo}
			setGearOrder={setGearOrder}
			setLoading={setLoading}
			setActionResponse={setActionResponse}
		/>
	));

	return (
		<>
			{actionResponse?.message && (
				<div
					id="action-response"
					className={
						'alert bold ' +
						(actionResponse?.status === 'danger' ||
						actionResponse?.status === 'success' ||
						actionResponse?.status === 'info' ||
						actionResponse?.status === 'warning'
							? `alert-${actionResponse.status}`
							: 'alert-info')
					}
				>
					{actionResponse.message}
				</div>
			)}
			<hr style={{ borderTop: '1px solid #929292', margin: '20px 0 20px 0' }} />
			<h3 className="bold">Ordered Products</h3>
			{productSections}
		</>
	);
};
